import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmailMessage, EmailMessageFilter } from '../common/EmailMessage';
import { PagedResult, PagingParams, pagingToHttpParams } from '../common/PagedResult';
import { ApiServiceBase } from './ApiServiceBase';

// Backend #657 slice 3: BFF pass-through to Email.Api's operator surface (carrier-admin only).
// The list is server-paged (#648: skip/take/sortBy/sortDescending, take from ListPageSize);
// retry answers 200 requeued / 404 unknown / 409 when the row is not Failed.
@Injectable({
  providedIn: 'root',
})
export class EmailMessageService extends ApiServiceBase {
  protected readonly path = 'emailmessages';

  getByFilter(
    filter?: EmailMessageFilter,
    paging?: PagingParams
  ): Observable<PagedResult<EmailMessage>> {
    return this.http
      .get<PagedResult<EmailMessage>>(this.getUrl(), { params: this.params(filter, paging) });
  }

  retry(id: string): Observable<EmailMessage> {
    return this.http
      .post<EmailMessage>(this.getUrl() + '/' + id + '/retry', null);
  }

  // Empty filters are omitted entirely (HttpClient would send the literal "undefined"/"null").
  private params(filter?: EmailMessageFilter, paging?: PagingParams): HttpParams {
    let params = new HttpParams({ fromObject: pagingToHttpParams(paging) });
    if (filter?.status) {
      params = params.set('status', filter.status);
    }
    if (filter?.recipient) {
      params = params.set('recipient', filter.recipient);
    }
    if (filter?.templateKey) {
      params = params.set('templateKey', filter.templateKey);
    }
    if (filter?.correlationId) {
      params = params.set('correlationId', filter.correlationId);
    }
    return params;
  }
}
